import {
    GET_ALL_FILES,
    DOWNLOAD_FILE,
    UPLOAD_FILE,
    GET_FILES_BY_IDS,
    DELETE_FILES_BY_IDS,
    GET_CURRENT_CONTENT
} from "../constants/action-types";

import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

/* 
    Get all File ids and types
*/

export const getAllFiles = (callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/attachments/AllFiles`, {
        method: "get"
    })
        .then(res => {
            dispatch({
                type: GET_ALL_FILES,
                payload: res.data
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

export const getFilesForIds = (fileIds, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/attachments?forIds=true`, {
        method: "post",
        data: fileIds
    })
        .then(res => {
            dispatch({
                type: GET_FILES_BY_IDS,
                payload: res.data
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

/* 
    Upload File
*/

export const uploadFile = (metadata, file, callback) => dispatch => {

    const formData = new FormData()
    if (file != null) formData.append('file', file, metadata.DisplayName)
    if (metadata?.id != null) { formData.append('id', metadata.id) }
    formData.append('fileType', metadata.Type || "File")
    formData.append('fileName', metadata.DisplayName || "unknown")
    formData.append('tags', JSON.stringify(metadata.Tags || []))

    const headers = {
        "Content-Type": "multipart/form-data"
    }

    adalApiFetch(Axios, `${API_CONFIG.URL}/attachments/UploadAttachment`, {
        method: "post",
        headers: headers,
        data: formData
    })
        .then(res => {
            dispatch({
                type: UPLOAD_FILE,
                payload: null
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

export const downloadFileBlob = (fileId, callback) => dispatch => {

    adalApiFetch(Axios, `${API_CONFIG.URL}/attachments/DownloadFile?isWebAdmin=${true}&id=${fileId}`, {
        method: "get"
    })
        .then(res => {
            const imageUrl = res.data

            callback(imageUrl)
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(null);
        })
}

export const deleteFiles = (fileIdList, callback) => dispatch => {

    const body = {
        FileIds: fileIdList
    }

    adalApiFetch(Axios, `${API_CONFIG.URL}/attachments/delete?forIds=true`, {
        method: "post",
        data: body
    })
        .then(res => {

            dispatch({
                type: DELETE_FILES_BY_IDS,
                payload: fileIdList
            })

            callback(true)
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
}

export const getCurrentContent = (contentId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/attachments?forIds=true`, {
        method: "post",
        data: [contentId]
    })
        .then(res => {
            dispatch({
                type: GET_CURRENT_CONTENT,
                payload: res.data
            });

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
}

export const getImageFromUrl = (url, fileName, callback) => dispatch => {

    const config = { responseType: 'blob' };

    Axios.get(url, config)
        .then(res => {
            const data = new File([res.data], fileName)

            callback(data);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })

}